import React, { createRef } from 'react'
import { Box, TextField, InputAdornment, IconButton } from '@mui/material'

import { faMagnifyingGlass } from '@fortawesome/pro-duotone-svg-icons/faMagnifyingGlass'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class DefaultSearchbar extends React.Component {
    constructor() {
        super()
        this.inputRef = createRef()
    }
    /*** How to use:
        <DefaultSearchbar kedo={this.props.kedo} handleChange={this.handleChange} handleSearch={this.handleSearch} searchName={this.state.searchName} resetButton={this.resetButton}/>
     ***/

    render() {
        return (
            <Box>
                <TextField
                    inputRef={this.inputRef}
                    name="searchName"
                    autoComplete="off"
                    onChange={this.props.handleChange}
                    onKeyUp={this.props.handleSearch}
                    placeholder={this.props.kedo.t('Search') + '...'}
                    type="text"
                    value={this.props.searchName}
                    fullWidth
                    size='small'
                    InputProps={{
                        endAdornment: (
                            <>
                                <InputAdornment position="end">
                                    <IconButton
                                        size='small'
                                        onClick={() =>
                                            this.props.handleSearch(
                                                this.inputRef
                                            )
                                        }
                                    >
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    </IconButton>
                                </InputAdornment>
                                {this.props.searchName &&
                                    this.props.searchName.length > 0
                                    ? this.props.resetButton()
                                    : null}
                                {this.props.appendButton
                                    ? this.props.appendButton
                                    : null}
                            </>
                        ),
                    }}
                />
            </Box>
        )
    }
}

export default DefaultSearchbar
